import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';

// Русский
import ruCommon from './locales/ru/common.json';
import ruMenu from './locales/ru/menu.json';
import ruAuth from './locales/ru/auth.json';
import ruDashboard from './locales/ru/dashboard.json';
import ruDevice from './locales/ru/device.json';
import ruBilling from './locales/ru/billing.json';
import ruAlerts from './locales/ru/alerts.json';
import ruErrors from './locales/ru/errors.json';
import ruProfile from './locales/ru/profile.json';
import ruAdmin from './locales/ru/admin.json';
import ruTax from './locales/ru/tax.json';

// Английский
import enCommon from './locales/en/common.json';
import enMenu from './locales/en/menu.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enDevice from './locales/en/device.json';
import enBilling from './locales/en/billing.json';
import enAlerts from './locales/en/alerts.json';
import enErrors from './locales/en/errors.json';
import enProfile from './locales/en/profile.json';
import enAdmin from './locales/en/admin.json';
import enTax from './locales/en/tax.json';

// Китайский
import zhCommon from './locales/zh/common.json';
import zhMenu from './locales/zh/menu.json';
import zhAuth from './locales/zh/auth.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhDevice from './locales/zh/device.json';
import zhBilling from './locales/zh/billing.json';
import zhAlerts from './locales/zh/alerts.json';
import zhErrors from './locales/zh/errors.json';
import zhProfile from './locales/zh/profile.json';
import zhAdmin from './locales/zh/admin.json';
import zhTax from './locales/zh/tax.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        common: ruCommon,
        menu: ruMenu,
        auth: ruAuth,
        dashboard: ruDashboard,
        device: ruDevice,
        billing: ruBilling,
        alerts: ruAlerts,
        errors: ruErrors,
        profile: ruProfile,
        admin: ruAdmin,
        tax: ruTax
      },
      en: {
        common: enCommon,
        menu: enMenu,
        auth: enAuth,
        dashboard: enDashboard,
        device: enDevice,
        billing: enBilling,
        alerts: enAlerts,
        errors: enErrors,
        profile: enProfile,
        admin: enAdmin,
        tax: enTax
      },
      zh: {
        common: zhCommon,
        menu: zhMenu,
        auth: zhAuth,
        dashboard: zhDashboard,
        device: zhDevice,
        billing: zhBilling,
        alerts: zhAlerts,
        errors: zhErrors,
        profile: zhProfile,
        admin: zhAdmin,
        tax: zhTax
      }
    },
    supportedLngs: ['ru', 'en', 'zh'],
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: ['common', 'menu', 'auth', 'dashboard', 'device', 'billing', 'alerts', 'errors', 'profile', 'admin', 'tax'],
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  });

export default i18n;
